// Search-result ordering for the Create-New-{Assessment,Resource} modal
// (FilteredItemList). Items whose TITLE contains the query rank above items
// that only match in the description; ties are broken alphabetically by
// title. With an empty query every item "matches" the empty substring, so
// this degrades to a plain alphabetical sort (the prior behaviour) — safe to
// call when unsearched.
//
// Kept in its own module (no heavy imports) so it stays unit-testable in
// isolation from the FilteredItemList component's large dependency graph.
export const sortBySearchRelevance = (list, rawQuery) => {
  const query = (rawQuery || '').toLowerCase().trim();
  return [...list].sort((a, b) => {
    const aTitleMatch = a.title.toLowerCase().includes(query);
    const bTitleMatch = b.title.toLowerCase().includes(query);
    if (aTitleMatch !== bTitleMatch) return aTitleMatch ? -1 : 1;
    return a.title.localeCompare(b.title);
  });
};
